import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { SITE } from "../content";

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service — Ridgehawk Logistics"
        description="The terms that govern your use of the Ridgehawk Logistics website and services."
        path="/terms"
      />
      <section className="section-pad bg-white" data-testid="terms-page">
        <div className="container-pad">
          <div className="mx-auto max-w-3xl">
            <span className="overline">Legal</span>
            <h1 className="h1 mt-4">Terms of Service</h1>
            <p className="body-base mt-4 text-ridge-muted">
              Last updated: April 29, 2026
            </p>

            <div
              className="mt-8 rounded-md border border-ridge-amber/40 bg-ridge-amber/10 p-5"
              data-testid="legal-disclaimer"
            >
              <p className="text-sm leading-relaxed text-ridge-text">
                <strong className="font-semibold">Disclaimer.</strong> This is a starting
                template provided for general informational purposes only. It is not
                legal advice and may not address every requirement that applies to your
                business or jurisdiction. Please consult a qualified lawyer to review
                and tailor these terms before relying on them.
              </p>
            </div>

            <div className="prose-ridge mt-12 max-w-none">
              <h2>1. Agreement</h2>
              <p>
                These Terms of Service ("Terms") govern your access to and use of{" "}
                {SITE.domain} (the "Site") operated by Ridgehawk Logistics Inc.
                ("Ridgehawk"). By using the Site, requesting a quote, or engaging our
                services, you agree to these Terms.
              </p>

              <h2>2. Services</h2>
              <p>
                Ridgehawk provides courier and logistics services including same-day
                local courier, medical and pharmaceutical transport, last-mile parcel
                delivery, B2B freight and cargo, and dedicated route contracts. The
                specific scope, pricing, and delivery commitments for any engagement
                are agreed in writing on a per-engagement basis. Information on the
                Site is for general informational purposes and does not constitute a
                binding offer.
              </p>

              <h2>3. Quote requests</h2>
              <p>
                A quote request submitted through the Site is an invitation for
                Ridgehawk to respond. It is not a contract until both parties confirm
                pricing and scope in writing.
              </p>

              <h2>4. Acceptable use</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Site or chat assistant to transmit unlawful, harmful, or fraudulent content.</li>
                <li>Attempt to gain unauthorised access to the admin area or any non-public portion of the Site.</li>
                <li>Probe, scan, or test the vulnerability of the Site without prior written consent.</li>
                <li>Interfere with the operation of the Site or attempt to bypass anti-spam, rate-limiting, or other protective controls.</li>
              </ul>

              <h2>5. Intellectual property</h2>
              <p>
                All content on the Site, including text, branding, logos, photographs,
                and code, is owned by Ridgehawk or its licensors and is protected by
                Canadian and international intellectual property laws. You may not
                reproduce, distribute, or create derivative works without our prior
                written consent.
              </p>

              <h2>6. Chat assistant</h2>
              <p>
                The on-site chat assistant uses an AI language model to provide
                conversational responses about our services. Responses may be
                inaccurate or out of date. Anything that materially affects pricing,
                scope, or availability must be confirmed by a Ridgehawk team member
                before you rely on it.
              </p>

              <h2>7. Disclaimers</h2>
              <p>
                The Site is provided "as is" and "as available". To the fullest extent
                permitted by law, Ridgehawk disclaims all warranties, whether express
                or implied, including merchantability, fitness for a particular
                purpose, and non-infringement.
              </p>

              <h2>8. Limitation of liability</h2>
              <p>
                To the fullest extent permitted by law, Ridgehawk shall not be liable
                for any indirect, incidental, special, consequential, or punitive
                damages arising out of or related to your use of the Site. Liability
                in connection with our paid services is governed by the written
                engagement signed by both parties.
              </p>

              <h2>9. Governing law</h2>
              <p>
                These Terms are governed by the laws of the Province of Ontario and
                the federal laws of Canada applicable in Ontario, without regard to
                conflict-of-law principles.
              </p>

              <h2>10. Changes</h2>
              <p>
                We may update these Terms from time to time. The "Last updated" date
                at the top of this page reflects the latest revision. Continued use of
                the Site after a change constitutes acceptance of the revised Terms.
              </p>

              <h2>11. Contact</h2>
              <p>
                Questions about these Terms can be sent to{" "}
                <a href={`mailto:${SITE.email}`}>{SITE.email}</a> or through our{" "}
                <Link to="/contact">contact page</Link>.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
